import PropTypes from 'prop-types';

export const Props = {
  /** The rich content*/
  content: PropTypes.string,
  /** If true, the rich-content block has a 100% width */
  block: PropTypes.bool,
  /** For CSS customization*/
  className: PropTypes.string,
};
